<template>
  <nx-form @form="form = $event" ref="form">
    <v-layout v-for="(file, index) in value" :key="file.blobUrl"
              class="nx-primary--lighten-5 pa-3 mt-2">
      <v-flex xs3>
        <v-img :src="file.blobUrl"
               :alt="file.name"
               contain
               height="124"
        />
      </v-flex>
      <v-flex xs9 class="ml-3">
        <component :is="formComponent"
                   :value="file.draft"
                   :disabled="disabled"
                   :scope="`wizard-${index}`"
                   validation-mode="eager"
                   @input="updateFileDraft(file, ...$event)"
                   @valid="updateValidForm(index, $event)"
        ></component>
      </v-flex>
    </v-layout>
  </nx-form>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import NxForm from '@/modules/form/Form';
import NxFormText from '@/modules/form/components/FormText';
import wizardConfig from '@/modules/content/wizard/config/wizard';

export default {
  name: 'nx-wizard-multiple-images-step2',
  components: {
    NxForm,
    NxFormText,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    draft: {
      type: Object,
      default: () => ({}),
    },
    disabled: Boolean,
  },
  data() {
    return {
      forms: [],
    };
  },
  computed: {
    formComponent() {
      return wizardConfig.NxWizardMultipleImagesForm;
    },
    everyFormIsValid() {
      return this.forms.every(valid => valid === true);
    },
  },
  methods: {
    internalValue() {
      return cloneDeep(this.value);
    },
    updateValidForm(index, valid) {
      this.$set(this.forms, index, valid);
    },
    updateFileDraft(file, draft) {
      this.$set(file, 'draft', draft);
    },
    update(internalValue) {
      this.$emit('input', internalValue);
    },
  },
  watch: {
    everyFormIsValid: {
      handler(value) {
        this.$emit('valid', value);
      },
      immediate: true,
    },
  },
};
</script>
